import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "up-divided-card",
  templateUrl: "./divided-card.component.html",
  styleUrl: "./divided-card.component.css",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DividedCardComponent {
  @Input() title!: string;
  @Input() description?: string;
  @Input() isLoading: boolean = false;
}
